import React, {Component} from 'react';
import {Box, Flex, Image, Text} from 'rebass';
import {Block, Input, Tabs} from 'reakit'
import {height, maxHeight} from "styled-system";
import {withRouter} from "react-router";
import {Link} from "react-router-dom";
import styled from "styled-components";
import { uniq } from 'lodash-es';

/**
 * Custom components
 */
import {Content, DesktopBox, MobileBox, MobileHeader, PositionBox, TabHeader, Toolbar} from "../../components/Base";
import {PageSubTitle, PageTitle} from "../../components/Base/Text";
import UserList from '../../components/UserList'
import Loading from '../../components/Base/Loading'
import {FloatingButton, SaveButton} from "../../components/Base/Buttons";
import StudentFilterDropdown from '../../components/Search/StudentFilterDropdown'
import ApplyFilter from '../../components/Search/ApplyFilters';
import ConfirmDelete from '../../components/Modals/ConfirmDelete';
import BasicSearch from '../../components/Forms/BasicSearch'

import {filterSearchResults, returnFilterString} from "../../utils";

/**
 * Theme
 */
import check from "../../resources/img/icons/Checkbox@1x.png";


const ListWrapper = styled(Box)`
${maxHeight}
${height}
margin-top: 18px
`

ListWrapper.defaultProps = {
	height: ['calc(100vh - 162px)', 'calc(100vh - 330px)']
};

class NewChat extends Component {

	state = {
		name: '',
		selected: [],
		search: '',

		filters: {
			grade: [],
			location: [],
			dorm: [],
			gender: [],
			type: []
		}, 
		rosterFilter: [],
		rosters: [],
		confirmDelete: false,
		deleteRosterData: {},
		locationSearch: '',
		disableFilter: false,
        isStudentTab: true
	};

	componentDidMount() {
		this.fetchRosters();
	}	

	fetchRosters = async () => {
		const { profile } = this.props;
		let result = [];
		let myRosters = await this.props.firebase.rosters().where('creator_uid', '==', profile.id).get();
	    myRosters.forEach(doc => (result.push({ id: doc.id, ...doc.data() })));
		let sharedRosters = await this.props.firebase.rosters().where('shared_with', 'array-contains', profile.id).get();
	    sharedRosters.forEach(doc => (result.push({ id: doc.id, ...doc.data() })));
		this.setState({ rosters: result })
	};

	componentWillUnmount() {
	}

	confirmDeleteRoster = () => {
		const data = this.state.deleteRosterData;
		const { profile, isFaculty, firebase, history } = this.props;
		if (isFaculty && profile.id === data.creator_uid) {
			firebase.chat(data.chat_uid).delete().then(() => console.log('Roster chat deleted succesfully')).catch(error => console.log("Error removing document: ", error));
			firebase.roster(data.id).delete().then(() => {
				history.replace('/app/chat/new');
				history.push('/app/chat/new');
				this.setState({ confirmDelete: false, deleteRosterData: {} });
			})
				.catch(error => console.log("Error removing document: ", error))
		}
	};

	handleSubmit = async () => {
		const {selected, name} = this.state;
		const {profile, isFaculty, firebase, history, updateChatId, width} = this.props;
		let status = 0;
		if (isFaculty) {
			status = 1
		}
		let isGroup = false;
		let accepted = {status: status, updated_at: Math.floor(Date.now() / 1000)};
		if (selected.length > 1) {
			isGroup = true;
			accepted = {status: status, updated_at: Math.floor(Date.now() / 1000), members: [], declined: {}}
		}
		const members = [profile.id, ...selected];
		let result = false;
		if (isGroup === false) {
			result = await this.checkIfExists(members)
		}

		if (result !== true) {
			let newChatRef = firebase.chats().doc();
			newChatRef.set({
				creator_uid: profile.id,
				is_group: isGroup,
				members: members,
				post_time: Math.floor(Date.now() / 1000),
				last_updated: Math.floor(Date.now() / 1000),
				messages: [],
				accepted,
				name
			})
			if(width < 700){
				history.replace('/app/chat')
				history.push(`/app/chat/${newChatRef.id}`);
			} else {
				updateChatId(newChatRef.id)
				history.replace('/app/home')
				history.push('/app/chat')
			}

		}

	};

	checkIfExists = async (members) => {
		const {firebase, history, width, updateChatId} = this.props;
		try {
			let chatQuery = await firebase.chats().where('members', '==', members).where('is_group', '==', false).get();
			// console.log('chatquery', chatQuery);
			if (chatQuery.docs.length > 0) {
				if(width < 700){
					history.replace('/app/chat')
					history.push(`/app/chat/${chatQuery.docs[0].id}`);
				} else {
					updateChatId(chatQuery.docs[0].id)
					history.replace('/app/home')
					history.push('/app/chat')
				}
				return true
			} else {
				chatQuery = await firebase.chats().where('members', '==', members.reverse()).where('is_group', '==', false).get();
				if (chatQuery.docs.length > 0) {
					if(width < 700){
						history.replace('/app/chat')
						history.push(`/app/chat/${chatQuery.docs[0].id}`);
					} else {
						updateChatId(chatQuery.docs[0].id)
						history.replace('/app/home')
						history.push('/app/chat')
					}
					return true
				}
			}
		} catch (err) {
			console.log(err)
		}
		return false
	};

	handleSelect = (details) => {
		let {selected} = this.state;
		console.log('new chat', details);
		let contains = false;
		for (var i = selected.length - 1; i >= 0; i--) {
			if (selected[i] === details.id) {
				selected.splice(i, 1);
				contains = true;
				this.setState({selected})
				// break;       //<-- Uncomment  if only the first term has to be removed
			}
		}

		if (!contains) {
			selected.push(details.id);
			this.setState({selected})
		}

	};

	filterListWithSearch = (list, search = '') => {
		// console.log( search)
		return list.filter(student => {
			// console.log(student)
			if (student.first_name) {
				return (student.first_name.toLowerCase() + ' ' + student.last_name.toLowerCase()).includes(search.toLowerCase())

			} else {
				return false
			}
		})
	};

	handleInput = (e) => {
		this.setState({name: e.target.value})
	};

	filteredByRoster = students => {
		const { rosterFilter } = this.state;
		let newData = [];
		rosterFilter.forEach(obj => {
			newData.push(...obj.students_uid);
		});

		let rosterStudentId = uniq(newData);

		if (rosterStudentId.length === 0) {
			return students
		} else {
			return students.filter(obj => rosterStudentId.includes(obj.id))
		}
	}

	switchTab = (type) => {
		this.props.clearSearch();
		if(type === 'Faculty') {
			/**
			 * Invisible Filter
			 */
			this.setState({disableFilter : true});
		} else {
			/**
			 * Visible Filter
			 */
			this.setState({disableFilter : false});
		}
	}

	updateFilter = (newFilters) => {
		this.setState({filters: newFilters})
	}

	updateRosterFilter = (newRosterFilter) => {
		this.setState({rosterFilter: newRosterFilter});
	}

	clearFilter = () => {
		this.setState({filters: {
			grade: [],
			location: [],
			dorm: [],
			gender: [],
			type: []
		}});
	}

	handleDeleteRoster = data => {
		this.setState({
			confirmDelete: true,
			deleteRosterData: data
		});
	};
		
	handleSearchChange = (e) => {
		this.setState({search: e.target.value});
	}

	render() {
		const {loading, students, faculty, profile, isFaculty, schoolInfo} = this.props;
		const {selected, name, rosters, disableFilter, search} = this.state;
		const count = selected.length;
		let id = 0;
		if (profile && profile.id) {
			id = profile.id
		}
		let studentList = students;
		studentList = filterSearchResults(this.state.filters, studentList);

		let facultyList = faculty;
		if (search !== null && search !== undefined) {
			if (facultyList.length > 0) {
				facultyList = this.filterListWithSearch(faculty, search)

			}
			if (studentList.length > 0) {
				studentList = this.filterListWithSearch(studentList, search)

			}
		}

		studentList = this.filteredByRoster(studentList);

		let disableButton = true
		if(count > 0 ){
			disableButton = false
		}

		const filterTitle = returnFilterString(this.state.filters, schoolInfo);

		return (
			<Box>
				<MobileBox>

					<FloatingButton disabled={disableButton} bg={disableButton ? 'meta': 'purple'} onClick={this.handleSubmit}><Image src={check}/></FloatingButton>
				</MobileBox>
				<DesktopBox  pl={3} pb={3} pt={3}>
						<Flex>
						<Box pl={3} mb={1} pt={2} width={1/2} >
							<SaveButton disabled={disableButton}
										onClick={this.handleSubmit} m={1}
										bg={disableButton ? 'gray': 'purple'}>{'Create'}</SaveButton>
							<Link to={'/app/chat'}><SaveButton m={1} bg={'metaText'}>Discard</SaveButton></Link>
						</Box>
							<Box ml={'auto'}/>
							{profile !== null && isFaculty &&
							<Box width={[ 2/5]} pt={3} pr={'8px'}>
								<BasicSearch handleInput={this.handleSearchChange} search={search} placeholders={this.state.isStudentTab ? 'Search Student' : 'Search Faculty'}/>
							</Box>}
						</Flex>
				</DesktopBox>
				<Tabs.Container>
					{tabs => (
						<Block>
							<MobileHeader>

								<PageTitle pt={2} color={'#263039'}>{count <= 1 ? 'New Chat':
									<Input placeholder={'Group name...'} maxHeight='27px' padding={0} margin={0} color={'#263039'}  width={'90%'} value={name}
									       onChange={this.handleInput}/>
									}</PageTitle>

									<PageSubTitle>{count} selected</PageSubTitle>
									{
										isFaculty &&
										<ApplyFilter 
											isNew={true}
											filters={JSON.parse(JSON.stringify(this.state.filters))} 
											clearFilter={this.clearFilter} 
											school={schoolInfo}
											updateFilters={this.updateFilter}
											rosters={rosters}
											rosterFilter={this.state.rosterFilter}
											updateRosterFilter={this.updateRosterFilter}
											handleDeleteRoster={this.handleDeleteRoster}
										/>	
									}

								<Tabs>
									<Tabs.Tab tab="first" {...tabs}><TabHeader
										onClick={() => {
											this.setState({isStudentTab: true});
											this.props.clearSearch()
										}} title={'Students'}/></Tabs.Tab>
									<Tabs.Tab tab="second" {...tabs}><TabHeader
										onClick={() => {
											this.setState({isStudentTab: false});
											this.props.clearSearch()
										}} title={'Faculty'}/></Tabs.Tab>
								</Tabs>

							</MobileHeader>

							<Content>
								<MobileBox>
									<PositionBox position={'fixed'} top={'169px'} width={1} zIndex={999}>
										{!loading && <BasicSearch handleInput={this.handleSearchChange} search={search} placeholders={this.state.isStudentTab ? 'Search Student' : 'Search Faculty'}/>}
									</PositionBox>
								</MobileBox>
								<DesktopBox>
									<PageTitle color={'#263039'}  pl={3}>{count > 1 ? <Input placeholder={'Group name...'} width={'40%'} value={name}
									                                      onChange={this.handleInput} color='#263039' maxHeight='30px' padding={0} margin={0}/>
									                                      : 'New Chat'}</PageTitle>

									<Text pl={4} pb={3} color={'meta'} fontWeight={600}>{count} selected</Text>
									{	isFaculty &&
											<Toolbar p={2} bg={'white'} boxShadow={['none', 'main']}>
												<Flex flexDirection={'row'}>
													<Box ml={5}>
														<Text 
															fontSize={0} 
															fontWeight={700} 
															py={2} 
															mt={'3px'}
															color={'meta'}
														>FILTER
														</Text>
													</Box> 
													<Flex ml={3} pt={2} style={{display: disableFilter ? 'none' : 'block'}}>
														<StudentFilterDropdown
															noLocation
															updateFilters={this.updateFilter}
															clearFilter={this.clearFilter}
															filters={this.state.filters}
															titleColor={'black'}
															title={filterTitle}
															rosters={rosters}
															rosterFilter={this.state.rosterFilter}
															updateRosterFilter={this.updateRosterFilter}
															handleDeleteRoster={this.handleDeleteRoster}
														/>
														<ConfirmDelete
															visible={this.state.confirmDelete}
															toggle={() => this.setState({ confirmDelete: false, deleteRosterData: {} })}
															handleConfirm={this.confirmDeleteRoster}
														/>
													</Flex>
												</Flex>
											</Toolbar>
									}
									
									<Tabs>
										<Tabs.Tab tab="first" {...tabs}><TabHeader
											onClick={() => {
												this.setState({isStudentTab: true});
												this.switchTab('Students')
											}} title={'Students'}/></Tabs.Tab>
										<Tabs.Tab tab="second" {...tabs}><TabHeader
											onClick={() => {
												this.setState({isStudentTab: false});
												this.switchTab('Faculty')
											}} title={'Faculty'}/></Tabs.Tab>
									</Tabs>
								</DesktopBox>
								<Tabs.Panel tab="first" {...tabs}>
									{loading ? <Loading/> :

										<ListWrapper>

										<UserList students={studentList.filter(student => student.id !== id)}
										          handleUserClick={this.handleSelect} selected={selected} useWindow/>
										</ListWrapper>

									}
								</Tabs.Panel>
								<Tabs.Panel tab="second" {...tabs}>{loading ? <Loading/> :
							<ListWrapper>

									<UserList students={facultyList.filter(faculty => faculty.id !== id)}
									          handleUserClick={this.handleSelect} selected={selected} facultyList useWindow/>
								</ListWrapper>
								}</Tabs.Panel>

							</Content>

						</Block>
					)}
				</Tabs.Container>


			</Box>
		)
	}

}


export default withRouter(NewChat)
